import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useDispatch, useSelector } from 'react-redux';
import { DataGrid } from '@mui/x-data-grid';

import moment from 'moment';
import { selectWidth } from '../utility/Redux/profile';
import { useFocus } from '../utility/hooks/hooks';
import { selectToken } from '../utility/Redux/security';
import {
  setAlertWithTitle,
  setModCompanyHelpStatus,
  setSessionExpired,
  setSpinnerLoading,
} from '../utility/Redux/modal';
import GeniustextInput from '../utility/component/mastertext';
import {
  DeleteButton,
  ModifyButton,
  SaveButton,
  UndoButton,
} from '../utility/component/buttons';
import AlertModalTwoButton from '../utility/component/modals/alertWithTwoButton';
import ModalHeaderStyle from '../utility/component/styles/modalHeader';
import { Button } from '@mui/material';
import CreditTopUpModal from './topUpModal.js';
import ModCompanyHelp from '../utility/component/modals/modCompanyHelp.js';
import OtpAlert from '../utility/functions/otpAlert.js';
import { CallAPIPromise } from '../routeBilling/menu/dashboard/biiling/modal/comman.js';
export const defaultDataWhatspp = {
  company_email: '',
  whatsapp_number: '',
  messanger_id: '',
  account_sid: '',
  auth_token: '',
  issue_date: '',
  valid_till: '',
};
const MessageSetupMaster = () => {
  const headerRef = useRef();
  const navigate = useNavigate();

  const [saveData, setSaveData] = useState(defaultDataWhatspp);
  const [otpAlertStatus, setOtpAlertStatus] = useState(false);
  const [CompanyHelpStatus, setCompanyHelpStatus] = useState(false);
  const windowWidth = useSelector(selectWidth);
  const dispatch = useDispatch();
  const [messagerType, setmessagetype] = useState('');
  const [topUpModalStatus, setTopUpModalStatus] = useState(false);
  const [otp, setOtp] = useState('1234');
  const [emailRef, setEmailError] = useFocus();
  const [whatsappRef, setWhatsappError] = useFocus();
  const [msgIdRef, setMsgIdError] = useFocus();
  const [accSidRef, setAccSidError] = useFocus();
  const [authTokenRef, setAuthTokenError] = useFocus();
  const [issueDateRef, setIssueDateError] = useFocus();
  const [validTillRef, setValidTillError] = useFocus();

  const [alertTwoButtonModal, setAlertTwoButtonModal] = useState({
    title: '',
    msg: '',
    status: false,
    setStatus: '',
    button1: '',
    button1Click: '',
    button2: '',
    button2Click: '',
  });

  const [searchQuery, setSearchQuery] = useState('');
  const [fullList, setFulllist] = useState([]);

  const [rows, setRows] = useState([]);
  const columns = [
    {
      width: windowWidth <= 940 ? 80 : windowWidth <= 1156 ? 150 : 160,
      headerAlign: 'center',
      align: 'left',
      field: 'company_email',
      renderHeader: (params) => (
        <div className="text-[12px]">Company Email</div>
      ),
    },

    {
      width: windowWidth <= 940 ? 50 : windowWidth <= 1156 ? 120 : 125,
      headerAlign: 'center',
      align: 'left',
      field: 'whatsapp_number',
      renderHeader: (params) => <div className="text-[12px]">WhatsApp No.</div>,
    },
    {
      width: windowWidth <= 940 ? 30 : windowWidth <= 1156 ? 140 : 140,
      headerAlign: 'center',
      align: 'left',
      field: 'whatsapp_balance',
      renderHeader: (params) => (
        <div className="text-[12px]">WhatsApp Balance</div>
      ),
    },
    {
      width: windowWidth <= 940 ? 30 : windowWidth <= 1156 ? 140 : 150,
      headerAlign: 'center',
      align: 'left',
      field: 'sms_balance',
      renderHeader: (params) => <div className="text-[12px]">Sms balance</div>,
    },
  ];

  const columnsMobile = [
    {
      width: 150,
      headerAlign: 'center',
      align: 'left',
      field: 'company_email',
      renderHeader: (params) => (
        <div className="text-[12px]">Company Email</div>
      ),
    },

    {
      width: 90,
      headerAlign: 'center',
      align: 'left',
      field: 'whatsapp_balance',
      renderHeader: (params) => (
        <div className="text-[12px]">Watsapp Balance</div>
      ),
    },
    {
      width: 60,
      headerAlign: 'center',
      align: 'left',
      field: 'sms_balance',
      renderHeader: (params) => <div className="text-[12px]">SMS Balance</div>,
    },
  ];

  const clearState = () => {
    setSaveData(defaultDataWhatspp);
    setId('');
    setmessagetype('');
  };

  const token = useSelector(selectToken);

  const getMessageSetup = async () => {
    dispatch(setSpinnerLoading('Loading'));
    CallAPIPromise(
      '/api/whatsApp/loadMessageSetup',
      {
        company_email: '',
      },
      token
    )
      .then((p) => {
        if (!p.data.error) {
          const data = p.data.response;
          let rowList = [];

          for (let index = 0; index < data.length; index++) {
            rowList.push({
              ...data[index],
              id: index + 1,
            });
          }

          setRows(rowList);
          setFulllist(rowList);
        }
      })
      .catch((error) => {
        console.log(error.response.data.name);
        if (error.response.data.name === 'TokenExpiredError') {
          dispatch(setSessionExpired(true));
          console.log(error.response);
        }
      })
      .finally(() => {
        dispatch(setSpinnerLoading(false));
      });
  };

  useEffect(() => {
    getMessageSetup();
  }, []);

  useEffect(() => {
    if (searchQuery) {
      const regex = /\d+/;

      const searchItems = fullList.filter((item) => {
        if (regex.test(searchQuery.substring(0, 1))) {
          return item.whatsapp_number.toString().includes(searchQuery);
        } else {
          return item.company_email
            .toLowerCase()
            .includes(searchQuery.toLowerCase());
        }
      });
      setRows(searchItems);
    } else {
      setRows(fullList);
    }
  }, [searchQuery]);

  const [id, setId] = useState('');
  const saveAPI = () => {
    const data = {
      company_email: id ? saveData.company_email : saveData.company_email,
      whatsapp_number: saveData.whatsapp_number,
      messanger_id: saveData.messanger_id ? saveData.messanger_id : '',
      account_sid: saveData.account_sid ? saveData.account_sid : '',
      auth_token: saveData.auth_token ? saveData.auth_token : '',
      issue_date: saveData.issue_date,
      valid_till: saveData.valid_till,
    };

    CallAPIPromise(`/api/whatsApp/saveMessageSetup`, data, token)
      .then(async function (response) {
        if (!response.data.error) {
          clearState();

          id
            ? dispatch(
                setAlertWithTitle({
                  title: 'Success.',
                  msg: 'Data Updated successfully.',
                  lottie: 'success',
                })
              )
            : dispatch(
                setAlertWithTitle({
                  title: 'Success.',
                  msg: 'Data Saved successfully.',
                  lottie: 'success',
                })
              );

          getMessageSetup();
        } else {
          dispatch(
            setAlertWithTitle({
              title: 'Error 112',
              msg: response.data.error,
            })
          );
          console.log(!response.data.error);
        }
      })
      .catch(function (error) {
        if (error.response.data.name === 'TokenExpiredError') {
          dispatch(setSessionExpired(true));
          console.log(error.response);
        } else {
          dispatch(
            setAlertWithTitle({
              title: 'ERROR',
              msg: 'Something went wrong.',
              lottie: 'reject',
            })
          );
        }
      })
      .finally(() => {
        dispatch(setSpinnerLoading(false));
      });
  };

  const saveMessageSetupApi = () => {
    if (
      (saveData.company_email && saveData.issue_date && saveData.valid_till) ||
      id
    ) {
      id
        ? dispatch(setSpinnerLoading('Updating'))
        : dispatch(setSpinnerLoading('Saving'));
      saveAPI();
    } else {
      if (!saveData.valid_till) {
        dispatch(
          setAlertWithTitle({
            title: 'ERROR',
            msg: 'Please Select Date Till Valid.',
            lottie: 'reject',
          })
        );
        setValidTillError();
      }

      if (!saveData.issue_date) {
        dispatch(
          setAlertWithTitle({
            title: 'ERROR',
            msg: 'Please Select Issue Date.',
            lottie: 'reject',
          })
        );
        setIssueDateError();
      }

      if (!saveData.company_email) {
        dispatch(
          setAlertWithTitle({
            title: 'ERROR',
            msg: 'Please Enter Company Email.',
            lottie: 'reject',
          })
        );
        setEmailError();
      }
    }
  };

  const deleteMessageSetupApi = () => {
    const data = {
      company_email: saveData.company_email,
      message_type: messagerType,
    };

    dispatch(setSpinnerLoading('Deleting'));

    CallAPIPromise(`/api/whatsApp/deleteMessageSetup`, data, {
      token,
    })
      .then(async function (response) {
        if (!response.data.error) {
          dispatch(
            setAlertWithTitle({
              title: 'Success.',
              msg: 'Data Deleted successfully.',
              lottie: 'success',
            })
          );
          getMessageSetup();
        } else {
          dispatch(
            setAlertWithTitle({
              title: 'Error 112',
              msg: response.data.error,
            })
          );
          console.log(!response.data.error);
        }
      })
      .catch((error) => {
        if (error.response.data.name === 'TokenExpiredError') {
          dispatch(setSessionExpired(true));
        } else {
          dispatch(
            setAlertWithTitle({
              title: 'ERROR',
              msg: 'Something went wrong.',
              lottie: 'reject',
            })
          );
        }
      })
      .finally(() => {
        dispatch(setSpinnerLoading(false));
        clearState();
      });
  };

  const formRef = useRef(null);

  useEffect(() => {
    const inputFields = formRef.current.querySelectorAll('input, select');

    inputFields.forEach((field, index) => {
      field.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          const nextIndex = (index + 1) % inputFields.length;
          if (index === 2) {
            inputFields[4].focus();
          }
          if (index === 3) {
            inputFields[5].focus();
          }
          if (index === 11) {
            inputFields[0].focus();
          } else {
            inputFields[nextIndex].focus();
          }
        }
      });
    });

    return () => {
      inputFields.forEach((field) => {
        field.removeEventListener('keydown', () => {});
      });
    };
  }, []);

  return (
    <div className="w-full h-full flex justify-center bg-[#f5f5f7] px-4 py-4 overflow-y-scroll">
      <div className="text-sm  rounded-sm  h-full">
        <div ref={headerRef} className="bg-white   ">
          <ModalHeaderStyle
            header={'Message Setup Master'}
            onClose={() => {
              navigate('/settings');
            }}
          />
        </div>

        <div
          style={{
            height: headerRef.current
              ? `calc(100% - ${headerRef.current.clientHeight}px)`
              : '90%',
          }}
          className="flex flex-col  "
        >
          <div className="px-6 py-3 bg-white" ref={formRef}>
            <div className="t:flex ">
              <div className="grid grid-cols-1">
                <GeniustextInput
                  title={'Company Email'}
                  width={windowWidth <= 500 ? '155px' : '400px'}
                  autofocus={true}
                  type={'text'}
                  grid={true}
                  value={saveData.company_email}
                  onChange={(e) => {
                    setSaveData((s) => {
                      return {
                        ...s,
                        company_email: e.target.value,
                      };
                    });
                  }}
                  search={() => {
                    dispatch(setModCompanyHelpStatus(true));
                  }}
                  refrance={emailRef}
                />

                <GeniustextInput
                  type={'mobile'}
                  grid={true}
                  title={'WhatsApp Number'}
                  width={windowWidth <= 500 ? '155px' : '400px'}
                  value={saveData.whatsapp_number}
                  onChange={(e) => {
                    setSaveData((s) => {
                      return {
                        ...s,
                        whatsapp_number: e.target.value,
                      };
                    });
                  }}
                  refrance={whatsappRef}
                />

                <div className="grid grid-cols-2 gap-2">
                  <GeniustextInput
                    type={'date'}
                    grid={true}
                    title={'Issue Date'}
                    width={windowWidth <= 500 ? '155px' : '195px'}
                    value={saveData.issue_date}
                    onChange={(e) => {
                      setSaveData((s) => {
                        return {
                          ...s,
                          issue_date: e.target.value,
                        };
                      });
                    }}
                    refrance={issueDateRef}
                  />
                  <GeniustextInput
                    type={'date'}
                    title={'Valid Till'}
                    grid={true}
                    width={windowWidth <= 500 ? '155px' : '195px'}
                    value={saveData.valid_till}
                    onChange={(e) => {
                      setSaveData((s) => {
                        return {
                          ...s,
                          valid_till: e.target.value,
                        };
                      });
                    }}
                    refrance={validTillRef}
                  />
                </div>
                <div className=" w-full  h-[64px] items-end flex   max-sm:hidden">
                  <Button
                    variant="contained"
                    onClick={() => {
                      setTopUpModalStatus(true);
                    }}
                    style={{
                      borderRadius: 7,
                      textTransform: 'none',
                      letterSpacing: '1px',
                      backgroundColor: '#f1a600',
                    }}
                  >
                    <div className="text-black px-4   text-[12px] t:text-[13px]">
                      Add Credits
                    </div>
                  </Button>
                </div>
              </div>
              <div className="t:ml-2">
                <GeniustextInput
                  width={windowWidth <= 500 ? '155px' : '400px'}
                  type={'text'}
                  grid={true}
                  title={'Messanger ID'}
                  placeholder={'MG33'}
                  value={saveData.messanger_id}
                  onChange={(e) => {
                    setSaveData((s) => {
                      return {
                        ...s,
                        messanger_id: e.target.value,
                      };
                    });
                  }}
                  refrance={msgIdRef}
                />
                <GeniustextInput
                  width={windowWidth <= 500 ? '100px' : '400px'}
                  type={'text'}
                  title={'Account SID'}
                  grid={true}
                  value={saveData.account_sid}
                  onChange={(e) => {
                    setSaveData((s) => {
                      return {
                        ...s,
                        account_sid: e.target.value,
                      };
                    });
                  }}
                  refrance={accSidRef}
                />
                <GeniustextInput
                  width={windowWidth <= 500 ? '100px' : '400px'}
                  type={'text'}
                  grid={true}
                  title={'Auth. Token'}
                  value={saveData.auth_token}
                  onChange={(e) => {
                    setSaveData((s) => {
                      return {
                        ...s,
                        auth_token: e.target.value,
                      };
                    });
                  }}
                  refrance={authTokenRef}
                />
                <div className="grid grid-cols-3 gap-1 w-full justify-end h-[64px] items-end   max-sm:hidden">
                  {id ? (
                    <ModifyButton
                      onClick={() => {
                        saveMessageSetupApi();
                      }}
                    />
                  ) : (
                    <SaveButton
                      onClick={() => {
                        saveMessageSetupApi();
                      }}
                    />
                  )}
                  <UndoButton onClick={clearState} />
                </div>
              </div>
            </div>

            <div className="flex w-full justify-between  items-center t:hidden">
              {id ? (
                <ModifyButton
                  onClick={() => {
                    saveMessageSetupApi();
                  }}
                />
              ) : (
                <SaveButton
                  onClick={() => {
                    saveMessageSetupApi();
                  }}
                />
              )}
              <UndoButton onClick={clearState} />
              <DeleteButton onClick={deleteMessageSetupApi} />
            </div>

            <div className="bg-white h-[250px] max-sm:mt-3 mt-4">
              <DataGrid
                hideFooterPagination
                headerHeight={0}
                rowHeight={30}
                showCellRightBorder={true}
                showColumnRightBorder={true}
                hideFooter
                getRowId={(p) => p.id}
                onRowClick={(p) => {
                  setmessagetype(p.row.message_type);
                  setId(p.id);
                  setSaveData({
                    ...p.row,
                    issue_date: moment(p.row.issue_date).format('YYYY-MM-DD'),
                    valid_till: moment(p.row.valid_till).format('YYYY-MM-DD'),
                  });
                  setSearchQuery('');
                }}
                components={{
                  Header: () => {
                    const headerDetails =
                      windowWidth <= 500 ? columnsMobile : columns;
                    return (
                      <div
                        className="  bg-[#383535] flex text-white text-lg "
                        style={{
                          borderTopLeftRadius: '3px',
                          borderTopRightRadius: '3px',
                          letterSpacing: '1px',
                        }}
                      >
                        {headerDetails?.map((item, index) => {
                          return (
                            <div
                              key={index}
                              className="  text-white flex justify-center items-center py-2  "
                              style={
                                item.flex
                                  ? index < headerDetails.length - 1
                                    ? {
                                        flex: item.flex,
                                        borderRight: '1px solid #b5b3b3',
                                        borderBottom: '1px solid #b5b3b3',
                                      }
                                    : {
                                        flex: item.flex,
                                        borderBottom: '1px solid #b5b3b3',
                                      }
                                  : index < headerDetails.length - 1
                                  ? {
                                      width: item.width,

                                      borderRight: '1px solid #b5b3b3',
                                      borderBottom: '1px solid #b5b3b3',
                                    }
                                  : {
                                      width: item.width,
                                      borderBottom: '1px solid #b5b3b3',
                                    }
                              }
                            >
                              {item.renderHeader()}
                            </div>
                          );
                        })}
                      </div>
                    );
                  },
                  NoRowsOverlay: () => {
                    return (
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          height: '100%',
                          width: '100%',
                        }}
                      >
                        No Records Found
                      </div>
                    );
                  },
                }}
                sx={
                  window.innerWidth < 770
                    ? {
                        backgroundColor: 'white',

                        fontSize: 12,
                        '& .super-app-theme--header': {
                          backgroundColor: '#f5f0e8',
                          display: 'none',
                        },
                        borderTop: '1px solid #b5b3b3',
                        borderRadius: 0,
                      }
                    : {
                        backgroundColor: 'white',
                        fontSize: 13,
                        borderTop: '1px solid #b5b3b3',
                        borderRadius: '3.5px',
                        '& .super-app-theme--header': {
                          backgroundColor: '#f5f0e8',
                          borderRight: `1px solid #b5b3b3`,

                          display: 'none',
                        },
                      }
                }
                columns={windowWidth <= 500 ? columnsMobile : columns}
                rows={rows}
                pageSize={100}
              />
            </div>
            <div className="bg-white mt-3">
              <input
                type="search"
                className="bg-[#E6E6E3] focus:outline-none px-2"
                style={{
                  border: '1px solid #b5b3b3',
                  height: '38px',
                  borderRadius: '6px',
                  width: windowWidth <= 500 ? '320px' : '400px',
                }}
                placeholder="Search"
                value={searchQuery}
                onChange={(e) => {
                  setSearchQuery(e.target.value);
                }}
              />
            </div>
          </div>
        </div>
      </div>

      <AlertModalTwoButton
        details={alertTwoButtonModal}
        setAlertTwoButtonModal={setAlertTwoButtonModal}
      />
      <ModCompanyHelp
        status={CompanyHelpStatus}
        onClose={() => {
          setCompanyHelpStatus(false);
        }}
        onRowClick={(p) => {
          setSaveData({
            ...defaultDataWhatspp,
            company_email: p.row.company_email,
          });
          setmessagetype('');
          dispatch(setModCompanyHelpStatus(false));
        }}
      />
      <CreditTopUpModal
        open={topUpModalStatus}
        onClose={() => {
          setTopUpModalStatus(false);
        }}
        setSaveData={setSaveData}
        data={saveData}
      />
      <OtpAlert
        status={otpAlertStatus}
        otp={otp}
        setOtpStatus={setOtpAlertStatus}
        onSubmit={saveAPI}
      />
    </div>
  );
};

export default MessageSetupMaster;
